const map = {
	"./action.mp3": "./src/mmod/mmodNotifications/sounds/action.mp3",
	"./alert.mp3": "./src/mmod/mmodNotifications/sounds/alert.mp3",
	"./beep.mp3": "./src/mmod/mmodNotifications/sounds/beep.mp3",
	"./bell.mp3": "./src/mmod/mmodNotifications/sounds/bell.mp3",
	"./buzz.mp3": "./src/mmod/mmodNotifications/sounds/buzz.mp3",
	"./chap.mp3": "./src/mmod/mmodNotifications/sounds/chap.mp3",
	"./chip.mp3": "./src/mmod/mmodNotifications/sounds/chip.mp3",
	"./chop.mp3": "./src/mmod/mmodNotifications/sounds/chop.mp3",
	"./click.mp3": "./src/mmod/mmodNotifications/sounds/click.mp3",
	"./click2.mp3": "./src/mmod/mmodNotifications/sounds/click2.mp3",
	"./error.mp3": "./src/mmod/mmodNotifications/sounds/error.mp3",
	"./error2.mp3": "./src/mmod/mmodNotifications/sounds/error2.mp3",
	"./gasp.mp3": "./src/mmod/mmodNotifications/sounds/gasp.mp3",
	"./glass.mp3": "./src/mmod/mmodNotifications/sounds/glass.mp3",
	"./keypress.mp3": "./src/mmod/mmodNotifications/sounds/keypress.mp3",
	"./knock.mp3": "./src/mmod/mmodNotifications/sounds/knock.mp3",
	"./knock2.mp3": "./src/mmod/mmodNotifications/sounds/knock2.mp3",
	"./master.mp3": "./src/mmod/mmodNotifications/sounds/master.mp3",
	"./message.mp3": "./src/mmod/mmodNotifications/sounds/message.mp3",
	"./no.mp3": "./src/mmod/mmodNotifications/sounds/no.mp3",
	"./note.mp3": "./src/mmod/mmodNotifications/sounds/note.mp3",
	"./notification.mp3": "./src/mmod/mmodNotifications/sounds/notification.mp3",
	"./pen.mp3": "./src/mmod/mmodNotifications/sounds/pen.mp3",
	"./question.mp3": "./src/mmod/mmodNotifications/sounds/question.mp3",
	"./swipe.mp3": "./src/mmod/mmodNotifications/sounds/swipe.mp3",
	"./switch.mp3": "./src/mmod/mmodNotifications/sounds/switch.mp3",
	"./tap.mp3": "./src/mmod/mmodNotifications/sounds/tap.mp3",
	"./top.mp3": "./src/mmod/mmodNotifications/sounds/top.mp3",
	"./ts.mp3": "./src/mmod/mmodNotifications/sounds/ts.mp3",
	"./tsi.mp3": "./src/mmod/mmodNotifications/sounds/tsi.mp3",
	"./tup.mp3": "./src/mmod/mmodNotifications/sounds/tup.mp3",
	"./wood.mp3": "./src/mmod/mmodNotifications/sounds/wood.mp3",
	"./yes.mp3": "./src/mmod/mmodNotifications/sounds/yes.mp3"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/mmod/mmodNotifications/sounds sync \\.mp3$";